import React, { useEffect } from 'react'
import AdditionalInformation from './sections/AdditionalInformation'
import BasicInfo from './sections/BasicInfo'
import ContactLens from './sections/ContactLens'
import ContactLensesService from './sections/ContactLensesService'
import Exams from './sections/Exams'
import FacilityAndBillingInformation from './sections/FacilityAndBillingInformation'
import Frame from './sections/Frame'
import Insured from './sections/Insured'
import Lab from './sections/Lab'
import Lens from './sections/Lens'
import Patient from './sections/Patient'
import Prescription from './sections/Prescription'
import { useDispatch } from 'react-redux'
import { eyefinityLensOptionsLoad } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/eyefinityInsuranceAction'

export default function EyefinityDynamicForm(props) {
  const { claimFormTemplate, formValues, page } = props
  const dispatch = useDispatch()
  const formConfig = claimFormTemplate?.config || {}
  const lensData = formConfig?.lens?.find((item) => item.label === 'lens')
  const material = formConfig?.lens?.find((item) => item.label === 'material').options.label
  const visionType = formConfig?.lens?.find((item) => item.label === 'vision_type').options.label
  const channelName = formConfig?.lens?.find((item) => item.label === 'finishing').options.label

  useEffect(() => {
    if (page !== 'page1' || !lensData) return
    dispatch(
      eyefinityLensOptionsLoad(formValues?.id, {
        materialType: material,
        visionType: visionType,
        channelName: channelName,
        pagesize: 10000
      })
    )

  }, [page, formValues?.id, material, visionType, channelName, lensData])

  const SECTION_COMPONENTS = {
    basic_info: BasicInfo,
    exams: Exams,
    lens: Lens,
    frame: Frame,
    lab: Lab,
    contact_lens: ContactLens,
    contact_lenses_service: ContactLensesService,
    prescription: Prescription,
    insured: Insured,
    patient: Patient,
    additional_information: AdditionalInformation,
    facility_and_billing_information: FacilityAndBillingInformation,
  }

  const PAGE_SECTIONS = {
    page1: [
      'basic_info',
      'exams',
      'lens',
      'frame',
      'lab',
      'contact_lens',
      'contact_lenses_service',
      'prescription',
    ],
    page2: [
      'insured',
      'patient',
      'additional_information',
      'facility_and_billing_information',
    ],
  }

  const sections = PAGE_SECTIONS[page] || []

  return (
    <>
      {sections.map(sectionName => {
        const SectionComponent = SECTION_COMPONENTS[sectionName]

        if (!SectionComponent || !Array.isArray(formConfig[sectionName])) return null

        return <SectionComponent key={sectionName} fields={formConfig[sectionName]} formValues={formValues} showRequiredMark={page === 'page1'} />
      })}
    </>
  )
}




